import React from 'react';
import { useSelector } from 'react-redux';
import { MODAL_TYPE, MODAL_ID, BUTTON_ID, BUTTON_NAME } from '../../constants';
import { getIsShowResetPasswordNotFoundIbError } from '../../selectors';
import ModalTemplate from '../layout/ModalTemplate';
import TymeButton from '../common/TymeButton';
import { Config } from '../../config';

export const ResetPasswordNotFoundIbErrorModal = () => {
    const isShow = useSelector(getIsShowResetPasswordNotFoundIbError);

    const onClickDownloadApp = () => {
        window.location.href = Config.registerUrl;
    };

    return (
        <ModalTemplate
            id={MODAL_ID.MODAL_RESET_PASSWORD_NOT_FOUND_IB_ERROR}
            title="Internet banking is no longer available"
            type={MODAL_TYPE.ERROR}
            isShow={isShow}
            handleHide={onClickDownloadApp}>
            <div>
                <p>Bank smarter with our App. Simply download the TymeBank app to access your account in one secure place and experience faster, safer banking.</p>

                <div className="btn-control-container">
                    <TymeButton
                        id={BUTTON_ID.RESET_PASSWORD_DONWLOAD_APP}
                        name={BUTTON_NAME.RESET_PASSWORD_DOWNLOAD_APP}
                        className="btn tyme-btn btn-primary"
                        onClick={onClickDownloadApp}>
                         Download the app
                    </TymeButton>
                </div>
            </div>
        </ModalTemplate>
    );
};

export default ResetPasswordNotFoundIbErrorModal;
